<template>
  <div class="home">
    <section
      class="main no-flex"
      style="margin-top: 13px;"
    >

      <EmployeeListing
        @click="handleUser"
        @show-other-component="showOtherComponent = true"
        @show-the-component="showOtherComponent = false"
      />
      <EmployeeDetailsListing
        v-if="!showOtherComponent"
        :user="user"
      />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import EmployeeDetailsListing from '@/components/EmployeePaymentDetailsListing.vue'
import EmployeeListing from '@/components/EmployeePaymentListing.vue'


export default {
  name: 'Home',
  components: {
    EmployeeDetailsListing,
    EmployeeListing,
  },
  data() {
    return {
      user: '',
      showOtherComponent: true,
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
  methods: {
    materialId(id) {
      this.materialIdToShow = id
    },
    handleUser(id) {
      this.user = id;
    },
  },
}
</script>

<style scoped lang="scss">

.main{
  padding: 90px 15px 15px 110px;
}

@media screen and (max-width: 1200px){
  .main{
    padding: 90px 15px 15px 90px;
  }
}

@media screen and (max-width: 1041px) {
  .main {
    padding: 90px 0.75rem 15px 0.75rem;
  }
}
</style>
